if (!window.__pressInitialized) {
  window.__pressInitialized = true;

  function initPressCarousel() {
    document.querySelectorAll(".js-press-carousel").forEach((element, index) => {
      if (element.classList.contains('is-initialized')) {
        return;
      }

      const uniqueClass = `js-press-carousel-${String(index + 1).padStart(2, "0")}`;
      element.classList.add(uniqueClass);

      const splide = new Splide(element, {
        type: 'loop',
        drag: 'free',
        gap: '60px',
        perPage: 3,
        rewind: false,
        arrows: false,
        pagination: false,
        autoScroll: {
          speed: 0.5,
        },
        breakpoints: {
          767: {
            perPage: 1
          },
          991: {
            perPage: 2
          },
          1198: {
            perPage: 3
          },
          1440: {
            perPage: 3
          }
        }
      });

      splide.mount(window.splide.Extensions);
    });
  }

  document.addEventListener("DOMContentLoaded", initPressCarousel);

  document.addEventListener('shopify:section:load', initPressCarousel);
  document.addEventListener('shopify:section:reorder', initPressCarousel);
  document.addEventListener('shopify:section:select', initPressCarousel);
  document.addEventListener('shopify:block:select', initPressCarousel);
  document.addEventListener('shopify:block:deselect', initPressCarousel);
}